angular.module('iqxCore').controller('CandidateComplianceCtrl', function ($scope, FormSvc, $sce, $location, $routeParams, toastSvc) {
  if ($routeParams.id) {
    $scope.PersonID = $routeParams.id
    FormSvc.setOptions($scope, {
      fetchAPI: 'callresult/netcandidatecompliance?pPersonID=' + $scope.PersonID,
      fetchWithPersonID: false,
      multiRow: true,
      numberFields: ['Score', 'AchievedScore', 'Behaviour', 'Status']
    })
  } else {
    FormSvc.setOptions($scope, {
      fetchAPI: 'callresult/netcandidatecompliance',
      fetchWithPersonID: true,
      multiRow: true,
      numberFields: ['Score', 'AchievedScore', 'Behaviour', 'Status']
    })
  }

  $scope.getBackground = function (item) {
    switch (item.Status) {
      case 1:
        return 'label-danger'
      case 2:
        return 'label-warning'
      default:
        return 'label-success'
    }
  }

  $scope.goToQuestions = function (item) {
    if($scope.PersonID){
        return toastSvc.info('Error', 'You do not have the permission to view this.', 'pageerror')
    }
    if (item.TagLocation === 'P') {
      $location.url('/candDetails')
    } else if (item.TagLocation !== 'P') {
      $location.url('/canddepartment?departmentid=' + item.TagLocation.slice(-2))
    }
  }

  $scope.showExplanation = function (item) {
    FormSvc.modalInfo(
      $scope,
      'complianceExplain',
      {
        caption: item.Description,
        trustedExplanation: $sce.trustAsHtml(item.Explanation),
        choices: [{ desc: 'Close', type: 'primary', code: '' }]
      },
      'lg'
    )
  }

  $scope.fetch()
})
